module.exports = __webpack_public_path__ + "static/media/icon-electric.3e46d5c7.png";